import { SVGProps, Ref, forwardRef } from 'react';

export const LightbulbOnFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M15.6 20.4c0 2.7-1.8 3.6-3.6 3.6s-3.6-.9-3.6-3.6v-.5h7.2z" fill="currentColor" />
                <path
                    d="M12 6a6 6 0 0 1 5.46 8.49c-.834 1.825-1.364 2.989-1.62 3.61H8.16c-.256-.621-.786-1.785-1.62-3.61A6 6 0 0 1 12 6"
                    fill="currentColor"
                />
                <path d="M4.253 11.1a8 8 0 0 0 0 1.8H0v-1.8z" fill="currentColor" />
                <path d="M24 12.9h-4.253a8 8 0 0 0 0-1.8H24z" fill="currentColor" />
                <path d="M7.16 5.886c-.473.374-.9.801-1.274 1.273L2.878 4.151 4.15 2.878z" fill="currentColor" />
                <path d="M21.122 4.151 18.113 7.16a7.8 7.8 0 0 0-1.273-1.273l3.009-3.008z" fill="currentColor" />
                <path d="M12.9 4.253a8 8 0 0 0-1.8 0V0h1.8z" fill="currentColor" />
            </g>
        </g>
    </svg>
));
LightbulbOnFilledSize24Glyph.displayName = 'LightbulbOnFilledSize24Glyph';
